var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{attrs:{"outlined":"","name":_vm.property.name,"value":_vm.property.value,"hide-details":""},on:{"blur":function($event){_vm.property.value = $event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }